import "./navbar"
import {debounce} from 'lodash'

const $window = $(window)
const $body = $('body');

const $pageWrapper = $('#page-wrapper')
const $headerToolbar = $('.header-toolbar')
const $headerMenu = $('.header-menu')
const $headerTitle = $('.header-title')
const $frontPageTopper = $('#front-page-topper')
const $frontPageBg = $('#front-page-bg')
const isFrontPage = $body.hasClass('is-front-page');

const calculateHeaderHeight = () => {
    const height = ($headerToolbar.outerHeight() || 0) + ($headerMenu.outerHeight() || 0) + ($headerTitle.outerHeight() || 0)

    if (isFrontPage) {
        // $frontPageTopper.css({
        //     'minHeight': 'auto',
        // })

        let h = $window.outerHeight() - height;

        if (h < $frontPageTopper.outerHeight()) {
            h = $frontPageTopper.outerHeight()
        }
        // $frontPageTopper.css({
        //     'minHeight': h + 'px',
        // })

        $frontPageBg.css({
            'height': (h + height) + 'px',
        })
    } else {
        $pageWrapper.css({
            '--headerHeight': height + 'px',
            '--headerBackgroundImage': 'url(' + window.siteConfig.singularBgUrl + ')'
        })
    }
}

calculateHeaderHeight()

$window.on("load resize", debounce(calculateHeaderHeight, 50));
